"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddEthereumChainParameters = exports.sendTransaction = exports.getTargetNetworkProvider = exports.buildWallet = exports.fetchManaBalance = exports.setTransactionsApiUrl = exports.getTransactionsApiUrl = void 0;

var eth_1 = require("web3x/eth");

var decentraland_transactions_1 = require("decentraland-transactions");

var schemas_1 = require("@dcl/schemas");

var ethers_1 = require("ethers");

var eth_2 = require("../../lib/eth");

var chainConfiguration_1 = require("../../lib/chainConfiguration");

var TRANSACTIONS_API_URL = 'https://transactions-api.decentraland.co/v1';

var getTransactionsApiUrl = function getTransactionsApiUrl() {
  return TRANSACTIONS_API_URL;
};

exports.getTransactionsApiUrl = getTransactionsApiUrl;

var setTransactionsApiUrl = function setTransactionsApiUrl(url) {
  return TRANSACTIONS_API_URL = url;
};

exports.setTransactionsApiUrl = setTransactionsApiUrl;

function fetchManaBalance(chainId, address) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var provider, contract, mana, balance;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return eth_2.getNetworkProvider(chainId);

          case 3:
            provider = _context.sent;
            contract = decentraland_transactions_1.getContract(decentraland_transactions_1.ContractName.MANAToken, chainId);
            mana = new ethers_1.Contract(contract.address, contract.abi, new ethers_1.providers.Web3Provider(provider));
            _context.next = 8;
            return mana.balanceOf(address);

          case 8:
            balance = _context.sent;
            return _context.abrupt("return", parseFloat(ethers_1.utils.formatEther(balance)));

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", 0);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));
}

exports.fetchManaBalance = fetchManaBalance;

function buildWallet() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var provider, eth, accounts, address, chainId, chainConfig, expectedChainId, expectedChainConfig, networks, _i, _Object$keys, network, networkChainId;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return eth_2.getConnectedProvider();

          case 2:
            provider = _context2.sent;

            if (provider) {
              _context2.next = 5;
              break;
            }

            throw new Error('Could not connect to Ethereum');

          case 5:
            eth = new eth_1.Eth(provider);
            _context2.next = 8;
            return eth.getAccounts();

          case 8:
            accounts = _context2.sent;

            if (!(accounts.length === 0)) {
              _context2.next = 11;
              break;
            }

            throw new Error('Could not get address');

          case 11:
            address = accounts[0].toString();
            _context2.next = 14;
            return eth.getId();

          case 14:
            chainId = _context2.sent;
            chainConfig = chainConfiguration_1.getChainConfiguration(chainId);
            expectedChainId = eth_2.getConnectedProviderChainId();
            expectedChainConfig = chainConfiguration_1.getChainConfiguration(expectedChainId);
            networks = {};
            _i = 0, _Object$keys = Object.keys(expectedChainConfig.networkMapping);

          case 20:
            if (!(_i < _Object$keys.length)) {
              _context2.next = 31;
              break;
            }

            network = _Object$keys[_i];
            networkChainId = expectedChainConfig.networkMapping[network];
            _context2.t0 = networkChainId;
            _context2.next = 26;
            return fetchManaBalance(networkChainId, address);

          case 26:
            _context2.t1 = _context2.sent;
            networks[network] = {
              chainId: _context2.t0,
              mana: _context2.t1
            };

          case 28:
            _i++;
            _context2.next = 20;
            break;

          case 31:
            return _context2.abrupt("return", {
              address: address.toLowerCase(),
              providerType: eth_2.getConnectedProviderType(),
              networks: networks,
              network: chainConfig.network,
              chainId: chainId
            });

          case 32:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.buildWallet = buildWallet;

function getTargetNetworkProvider(chainId) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var networkProvider;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return eth_2.getNetworkProvider(chainId);

          case 2:
            networkProvider = _context3.sent;
            return _context3.abrupt("return", new ethers_1.providers.Web3Provider(networkProvider));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.getTargetNetworkProvider = getTargetNetworkProvider;

function sendTransaction(contract, getPopulatedTransaction) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var connectedProvider, chainIdHex, chainId, targetNetworkProvider, contractInstance, unsignedTx, signer, tx, hash;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return eth_2.getConnectedProvider();

          case 2:
            connectedProvider = _context4.sent;

            if (connectedProvider) {
              _context4.next = 5;
              break;
            }

            throw new Error('Provider not connected');

          case 5:
            _context4.next = 7;
            return connectedProvider.request({
              method: 'eth_chainId',
              params: []
            });

          case 7:
            chainIdHex = _context4.sent;
            chainId = parseInt(chainIdHex, 16); // get a provider for the target network

            _context4.next = 11;
            return getTargetNetworkProvider(contract.chainId);

          case 11:
            targetNetworkProvider = _context4.sent;
            // intantiate the contract
            contractInstance = new ethers_1.Contract(contract.address, contract.abi, targetNetworkProvider); // populate the transaction data

            _context4.next = 15;
            return getPopulatedTransaction(contractInstance.populateTransaction);

          case 15:
            unsignedTx = _context4.sent;

            if (!(chainId === contract.chainId)) {
              _context4.next = 24;
              break;
            }

            signer = targetNetworkProvider.getSigner();
            _context4.next = 20;
            return signer.sendTransaction(unsignedTx);

          case 20:
            tx = _context4.sent;
            return _context4.abrupt("return", tx.hash);

          case 24:
            _context4.next = 26;
            return decentraland_transactions_1.sendMetaTransaction(connectedProvider, targetNetworkProvider, unsignedTx.data, contract, {
              serverURL: exports.getTransactionsApiUrl()
            });

          case 26:
            hash = _context4.sent;
            return _context4.abrupt("return", hash);

          case 28:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.sendTransaction = sendTransaction;

function getAddEthereumChainParameters(chainId) {
  var hexChainId = '0x' + chainId.toString(16);
  var chainName = schemas_1.getChainName(chainId);
  var config = chainConfiguration_1.getChainConfiguration(chainId);

  switch (chainId) {
    case schemas_1.ChainId.MATIC_MAINNET:
      return {
        chainId: hexChainId,
        chainName: chainName,
        nativeCurrency: {
          name: 'MATIC',
          symbol: 'MATIC',
          decimals: 18
        },
        rpcUrls: ['https://rpc-mainnet.maticvigil.com/'],
        blockExplorerUrls: ['https://polygonscan.com/']
      };

    case schemas_1.ChainId.MATIC_MUMBAI:
      return {
        chainId: hexChainId,
        chainName: chainName,
        nativeCurrency: {
          name: 'MATIC',
          symbol: 'MATIC',
          decimals: 18
        },
        rpcUrls: ['https://rpc-mumbai.maticvigil.com/'],
        blockExplorerUrls: ['https://mumbai.polygonscan.com/']
      };

    case schemas_1.ChainId.ETHEREUM_MAINNET:
    case schemas_1.ChainId.ETHEREUM_ROPSTEN:
    case schemas_1.ChainId.ETHEREUM_RINKEBY:
    case schemas_1.ChainId.ETHEREUM_KOVAN:
    case schemas_1.ChainId.ETHEREUM_GOERLI:
      return {
        chainId: hexChainId,
        chainName: chainName,
        nativeCurrency: {
          name: 'Ether',
          symbol: 'ETH',
          decimals: 18
        },
        rpcUrls: [config.rpcURL],
        blockExplorerUrls: ['https://etherscan.io']
      };
  }
}

exports.getAddEthereumChainParameters = getAddEthereumChainParameters;